import React from "react";
import { Layout } from "../layout";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Toolbar,
  Typography,
  Button,
} from "@material-ui/core";
import { MultiLineText } from "~/components";
import { HelpDialog } from "./components/Dialog";
import { useModule } from "./hooks";
import { dateFormat } from "~/helpers/date";

export const AdminHelp: React.VFC = () => {
  const classes = useStyles();
  const module = useModule();
  const {
    states: { openDialog, isHelpInit, helps, page, rowsPerPage },
    setters: {
      handleCloseDialog,
      handleOpenDialog,
      handleChangePage,
      handleChangeRowsPerPage,
    },
  } = module;

  return (
    <Layout loading={!isHelpInit}>
      <Paper className={classes.root}>
        <Toolbar className={classes.root}>
          <Typography className={classes.title} variant="h6" component="div">
            ヘルプ一覧
          </Typography>
          <div className={classes.buttons}>
            <Button
              className={classes.openDialogBtn}
              variant="contained"
              color="secondary"
              onClick={() => handleOpenDialog()}
            >
              ヘルプの登録
            </Button>
          </div>
        </Toolbar>
        <TableContainer className={classes.container}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 20 }}>No</TableCell>
                <TableCell>よくある質問</TableCell>
                <TableCell style={{ width: 240 }}>登録日</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {helps.length > 0 &&
                helps
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        key={`help_${index}`}
                        hover
                        onClick={() => handleOpenDialog(row)}
                        className={classes.row}
                      >
                        <TableCell>{index + page * rowsPerPage + 1}</TableCell>
                        <TableCell>
                          <MultiLineText>{row.question}</MultiLineText>
                        </TableCell>
                        <TableCell>{dateFormat(row.created)}</TableCell>
                      </TableRow>
                    );
                  })}
              {helps.length === 0 && (
                <TableRow hover>
                  <TableCell colSpan={3} align="left">
                    ヘルプが存在しません
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={helps.length}
          labelRowsPerPage="表示数:"
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />

        {/* 閲覧用ダイアログ */}
        <HelpDialog
          open={openDialog}
          onClose={handleCloseDialog}
          module={module}
        />
      </Paper>
    </Layout>
  );
};

const useStyles = makeStyles({
  root: {
    width: "100%",
    padding: 0,
    marginTop: 30,
  },
  container: {
    maxHeight: 500,
  },
  title: {
    textAlign: "left",
    marginLeft: 20,
    flex: "1 1 100%",
  },
  row: {
    cursor: "pointer",
  },
  buttons: {
    display: "flex",
    marginRight: 30,
  },
  openDialogBtn: {
    marginLeft: 20,
    width: 120,
  },
});
